import { render, staticRenderFns } from "./FontResource.vue?vue&type=template&id=c597bb2c&scoped=true"
import script from "./FontResource.vue?vue&type=script&lang=js"
export * from "./FontResource.vue?vue&type=script&lang=js"
import style0 from "./FontResource.vue?vue&type=style&index=0&id=c597bb2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c597bb2c",
  null
  
)

export default component.exports